import React from 'react';

import { TTitle } from "./types";
import { HeadlineTitle } from './styled'

export const Title = ({ title }: TTitle) => {
	return (
	   <HeadlineTitle>{title}</HeadlineTitle>
	);
};